import appAxios from '../../utils/appAxios.js';


export default {
    namespaced: true,
    state: {
        LocalizatonList: [],
        CountryList: [],
        CityList: [],
        DistrictList: []

    },
    getters: {

        _getLocalizatonList: (state) => state.LocalizatonList,
        _getCountryList: (state) => state.CountryList,
        _getCityList: (state) => state.CityList,
        _getDistrictList: (state) => state.DistrictList
    },
    mutations: {},
    actions: {

        async GET_LOCALİZATON({ state }) {
            await appAxios.get("/common/getLanguages").then(response => {
                if (response.data.Success) {
                    state.LocalizatonList = response.data.Data.map(language => ({ Id: Number(language.Id), Value: language.Value }))
                }
            })
        },
        async GET_ALL_COUNTRY({ state }) {
            await appAxios.get("/common/getCountries").then(response => {
                if (response.data.Success) {
                    state.CountryList = response.data.Data.map(country => ({ Id: Number(country.Id), Value: country.Value }))
                }
            })
        },

        async GET_CITYS({ state }, payload) {
            //Signup sayfasında 2şer ayrı ülke-şehir-ilçe dropdownu seçildiğinden dolayı new Promise ile değiştirildi
            return new Promise(resolve => {
                appAxios.get(`/common/getCitiesByCountryId?countryId=${payload}`).then((response) => {
                    if (response.data.Success) {
                        state.CityList = response.data.Data.map(city => ({ Id: Number(city.Id), Value: city.Value }))
                        resolve(response.data.Data.map(city => ({ Id: Number(city.Id), Value: city.Value })));
                    }
                    else resolve(null)
                }).catch(() => resolve(null))
            })
        },
        async GET_DISTRICT({ state }, payload) {
            //Signup sayfasında 2şer ayrı ülke-şehir-ilçe dropdownu seçildiğinden dolayı new Promise ile değiştirildi
            return new Promise(resolve => {
                appAxios.get(`/common/getDistrictsByCityId?cityId=${payload}`).then((response) => {
                    if (response.data.Success) {
                        state.DistrictList = response.data.Data.map(district => ({ Id: Number(district.Id), Value: district.Value }))
                        resolve(response.data.Data.map(district => ({ Id: Number(district.Id), Value: district.Value })));
                    }
                    else resolve(null)
                }).catch(() => resolve(null))
            })
        },

    }
}